module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-download-totale-button",
      "title": "Download"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13cd74cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/DownloadTotale.vue
// module id = 824
// module chunks = 39